<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>监控中心</el-breadcrumb-item>
        <el-breadcrumb-item>数据可视化</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-form :inline="true" :model="formInline" >
<!--        <el-form-item label="">
          <el-select  size="mini" clearable v-model="operatorId" @change="getOperatorIdValue" placeholder="请选择运营商">
            <el-option
              v-for="item in operators"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="" >
          <el-cascader  size="mini" @change="getOperatorIdValue" ref="cascader"
            placeholder="请选择运营商"
            :options="operatorsTree"
            :props="{ checkStrictly: true,expandTrigger: 'hover' }"
            :show-all-levels="false"
            change-on-select
            v-model="opsTree" clearable>
          </el-cascader>
        </el-form-item>
      </el-form>

      <el-tabs v-model="activeName" type="border-card"  @tab-click="tabClick">
        <el-tab-pane label="站点分布-力导图" name="highcharts1">
          <div>
            <x-chart id="highcharts" :option="option"></x-chart>
          </div>
        </el-tab-pane>
        <el-tab-pane label="站点分布-圆堆积图" name="highcharts2">
          <div>
                <x-chart id="highchart2" :option="option2"></x-chart>
              </div>
        </el-tab-pane>
      </el-tabs>

    </el-main>
  </el-container>
</template>

<script>
  import dataVisualApi from '../../monitoringCenter/api/dataVisualApi'

  //import commonApi from '@/common/api/commonFromVuexApi.js';
  import commonApi from '@/common/api/commonApi.js';
  // 导入chart组件
  //import Highcharts from 'highcharts';
  //var myvue = {};
  import XChart from '@/components/highCharts'
  export default {
    data() {
      return {
        operators:{},//运营商
        opsTree: [],
        operatorsTree: [],//运营商树
        formInline: { },
        operatorId:'',
        option:{},
        option2:{},
        activeName:'highcharts1',
        optionDataTemp:[]
      }
    },
    created () {
      //this.getOperators()
      this.getOperatorsTree()
    },
    methods:{
      // 获取运营商
      getOperators() {
        commonApi.getOperators().then((res) => {
          this.operators = res
          this.$set(this, 'operators', res)
        })
      },
      // 获取运营商下拉级联
      getOperatorsTree() {
        commonApi.getOperatorsTree().then((res) => {
          this.operatorsTree = res.data
        })
      },
      //绑定标签select
      getOperatorIdValue(value){
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        if (this.activeName == 'highcharts1'){
          this.getStationVisualGroupOperatorId(operatorId)
        }else if (this.activeName == 'highcharts2'){
          this.getStationVisualGroupAddress(operatorId)
        }
        console.log(this.opsTree)
        // this.opsTree= operatorId
        this.$refs.cascader.dropDownVisible = false
      },
      tabClick(tab, event) {
        let opsTree = this.opsTree
        let operatorId = opsTree &&opsTree.length >0 ? opsTree[opsTree.length-1] : ''
         console.log('operatorId:'+this.opsTree);
        if (this.activeName == 'highcharts1'){
          this.getStationVisualGroupOperatorId(operatorId)
        }else if (this.activeName == 'highcharts2'){
          this.getStationVisualGroupAddress(operatorId)
        }
      },
      color(){//rgb颜色随机
        var r = Math.floor(Math.random()*256);
        var g = Math.floor(Math.random()*256);
        var b = Math.floor(Math.random()*256);
        var color = '#'+r.toString(16)+g.toString(16)+b.toString(16);
        return color;
      },
      getStationVisualGroupOperatorId (operatorId) {
        dataVisualApi.getStationVisualGroupOperatorId(operatorId).then((res) => {
          if (res.code === 0) {
            this.optionDataTemp = res.data
            this.initOption(this.optionDataTemp)
          }else{

          }
        })
      },
      getStationVisualGroupAddress (operatorId) {
        dataVisualApi.getStationVisualGroupAddress(operatorId).then((res) => {
          if (res.code === 0) {
            this.optionDataTemp = res.data
            this.initOption2(this.optionDataTemp)
          }else{

          }
        })
      },
      initOption (optionDataTemp) {
        console.log(optionDataTemp)
        this.option = {
          chart: {
            type: 'networkgraph',
            zoomType: 'xy',
            // backgroundColor: '#c1c1c1'
          },
          title: {
            text: ''
          },
          subtitle: {
            text: ''
          },
          plotOptions: {
            networkgraph: {
              keys: ['from', 'to'],
              layoutAlgorithm: {
                enableSimulation: true,
                // linkLength: 80
              }
            }
          },
          series: [{
            dataLabels: {
              enabled: true,
              // textPath: {
              //   enabled: true
              // },
              linkFormat: '',
            },
            data:optionDataTemp
          }]
        };
        let nodes = [];
        this.option.series[0].nodes = nodes
        for(let item of this.option.series[0].data) {
          let color = this.color()
          if (item[0] === '充电运营管理云平台') {
            nodes.push({id: '充电运营管理云平台',
                marker: {
                  radius: 25
                },
              color: this.color()
            })
              nodes.push({
                id: item[1],
                marker: {
                  radius: 16
                },
                color: color
              })
          }else{
            nodes.push({
                id: item[1],
                marker: {
                  radius: 8
                },
                color: color
            })
          }
        }
      },
      initOption2 (optionDataTemp) {
        // console.log(optionDataTemp)
        let province = []
        let nodes =[]
        for(let item of optionDataTemp){
          if (province.indexOf(item["province"]) === -1){
            province.push(item["province"])
            // console.log(province)
            nodes.push({
              name: item["province"],
              data: [{
                name: item["city"],
                value: item["totalNum"]
              }]
            })
            // console.log(nodes)
          }else{
            for (let item1 of nodes){
              if (item["province"] == item1["name"]){
                item1["data"].push({
                  name: item["city"],
                  value: item["totalNum"]
                })
              }
            }
          }
        }
        this.option2 = {
          chart: {
            type: 'packedbubble',
            // height: '100%',
          },
          title: {
            text: ''
          },
          subtitle: {
            text: ''
          },
          tooltip: {
            useHTML: true,
            pointFormat: '<b>{point.name}:</b> 场站数量 {point.y}'
          },
          plotOptions: {
            packedbubble: {
              minSize: '30%',
              maxSize: '120%',
              zMin: 0,
              zMax: 1000,
              layoutAlgorithm: {
                gravitationalConstant: 0.05,
                splitSeries: true,
                seriesInteraction: false,
                dragBetweenSeries: false,
                parentNodeLimit: true,
              },
              dataLabels: {
                enabled: true,
                format: '{point.name}',
                // filter: {
                //   property: 'y',
                //   operator: '>',
                //   value: 0
                // },
                style: {
                  color: 'black',
                  textOutline: 'none',
                  fontWeight: 'normal'
                }
              }
            }
          },
          // series: [{
          //   name: '湖北',
          //   data: [
          //     {
          //     name: '武汉市',
          //     value: 10
          //   }, {
          //     name: '荆门市',
          //     value: 100
          //   },
          //     {
          //       name: "黄冈市",
          //       value: 1
          //     }]
          // }]
          series:nodes
        };
      }
    },
    beforeCreate:function(){
      // this.initOption ()
    },
    beforeMount:function(){

    },
    mounted: function () {
      this.getStationVisualGroupOperatorId('')
      this.getStationVisualGroupAddress('')
    },
    components: {
      XChart
    }
  }
</script>

<style scoped>
  #highcharts {
  }
</style>



// WEBPACK FOOTER //
// src/module/monitoringCenter/page/dataVisual.vue